import { serviceTypes, modulesConfig } from '../config';

export const moduleId = 'Stamps';
export const modulePath = serviceTypes[modulesConfig.Stamps.serviceType].path;

export const pagePaths = {
  Module: modulePath,
};
